import { useMemo } from "react";
import { useLocationStore } from "@/location/locationStore";
import { ListItem, ListItemText, Button, Stack, Typography, Chip } from "@mui/material";

export default function SettingsLocation() {
  const status = useLocationStore((s) => s.status);
  const userDeclined = useLocationStore((s) => s.userDeclined);
  const lastLocation = useLocationStore((s) => s.lastLocation);
  const requestLocation = useLocationStore((s) => s.requestLocation);
  const clearDecline = useLocationStore((s) => s.clearDecline);

  const statusLabel = useMemo(() => {
    if (status === "granted") return "Allowed";
    if (status === "denied") return "Denied";
    if (status === "blocked") return "Blocked by browser";
    if (status === "unsupported") return "Not supported";
    if (userDeclined) return "Declined";
    return "Not requested";
  }, [status, userDeclined]);

  const secondary = useMemo(() => {
    const items = [];
    if (lastLocation?.capturedAt) {
      const captured = new Date(lastLocation.capturedAt);
      if (!Number.isNaN(captured.getTime())) {
        items.push(`Last used ${captured.toLocaleString()}`);
      }
    }
    if (userDeclined) {
      items.push("You chose not to be prompted again.");
    }
    if (status === "denied") {
      items.push("Enable location in browser settings to re-allow.");
    }
    return items.length ? items.join(" · ") : undefined;
  }, [lastLocation?.capturedAt, status, userDeclined]);

  const actionLabel =
    status === "granted" ? "Re-check" : userDeclined ? "Enable" : "Request";

  const handleClick = async () => {
    clearDecline();
    await requestLocation("settings");
  };

  return (
    <ListItem
      secondaryAction={
        <Button
          variant="outlined"
          size="small"
          onClick={handleClick}
        >
          {actionLabel}
        </Button>
      }
    >
      <ListItemText
        primary={
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body1">Location</Typography>
            <Chip label={statusLabel} size="small" />
          </Stack>
        }
        secondary={secondary}
      />
    </ListItem>
  );
}
